import React, { useState } from 'react';
import Loadable from 'react-loadable';

import { FormApiError } from '../../forms';
import Loading from '../../ui/Loading';

import NewsletterSuccess from './NewsletterSuccess';

const LoadableComponent = Loadable({
  loader: () => import('./NewsletterForm'),
  loading: Loading
});

const NewsletterUsFormWrapper = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const handleFormError = (err) => {
    setErrorMessage(err);
  };

  const handleFormSuccess = () => {
    setIsSuccess(true);
  };

  const handleNewForm = () => {
    setIsSuccess(false);
  };

  if (isSuccess) {
    return <NewsletterSuccess onNewForm={handleNewForm} />;
  }
  return (
    <>
      {errorMessage && <FormApiError>{errorMessage}</FormApiError>}
      <LoadableComponent
        onFormSuccess={handleFormSuccess}
        onFormError={handleFormError}
      />
    </>
  );
};

export default NewsletterUsFormWrapper;
